export const LAST_IMPORT_COOKIE_NAME = 'lastimport';
export const IMPORT_STAGES = {
  UPLOADING: 0,
  UNPACKING: 1,
  VERIFYING: 2,
  UPDATING: 3,
  SUCCESS: 4,
};
